import { createContext, ReactNode } from 'react';
import { TransferAssetFlowReducerState } from '@providers/TransferAssetFlowProvider/useTransferAssetFlowState';
import { Wallet, BridgeTxNotification } from '@types';
import useSendTransaction from './useSendTransaction';

export const SendTransactionContext = createContext(
  {} as ISendTransactionProviderContext
);

interface ISendTransactionProviderContext {
  sendTransaction: (
    wallets: Wallet[],
    formState: TransferAssetFlowReducerState
  ) => Promise<string>;
  bridgeTxNotifications: BridgeTxNotification[];
  showBridgeTxNotification: (id: string) => void;
  hideBridgeTxNotification: (id: string) => void;
}

interface SendTransactionProviderProps {
  children: ReactNode;
}

const SendTransactionProvider = ({
  children,
}: SendTransactionProviderProps) => {
  const value = useSendTransaction();

  return (
    <SendTransactionContext.Provider value={value}>
      {children}
    </SendTransactionContext.Provider>
  );
};

export default SendTransactionProvider;
